class VinebiEmailPopup extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.doneKey = 'elirena:popup:done';
    this.snoozeKey = 'elirena:popup:snoozeUntil';
    const suppressed = () => {
      try { return localStorage.getItem(this.doneKey) === '1' || Number(localStorage.getItem(this.snoozeKey)) > Date.now(); } catch { return false; }
    };
    const open = () => {
      if (suppressed() || this.opened) return;
      if (document.querySelector('dialog[open], .menu-drawer-container[open], #shopify-pc__banner')) {
        setTimeout(open, 1000); return;
      }
      this.opened = true;
      this.previousFocus = document.activeElement;
      this.hidden = false;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.querySelector('input').focus({ preventScroll: true });
    };
    const delay = Number(matchMedia('(max-width:749px)').matches ? this.dataset.delayMobile : this.dataset.delay);
    this.timer = setTimeout(open, delay * 1000);
    this.scrollHandler = () => {
      const scroller = matchMedia('(min-width:990px)').matches ? document.querySelector('.page-wrapper') : document.scrollingElement;
      const distance = scroller.scrollHeight - scroller.clientHeight;
      if (distance > 0 && scroller.scrollTop / distance * 100 >= Number(this.dataset.scroll)) open();
    };
    document.addEventListener('scroll', this.scrollHandler, { passive: true, capture: true });
    this.exitHandler = event => { if (event.clientY <= 0 && this.dataset.exitIntent === '1' && matchMedia('(pointer:fine)').matches) open(); };
    document.addEventListener('mouseout', this.exitHandler);
    this.querySelectorAll('[data-ep-close], [data-ep-scrim]').forEach(button => button.addEventListener('click', () => this.close()));
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape') this.close();
      if (event.key !== 'Tab') return;
      const focusable = [...this.querySelectorAll('button, input, a[href]')].filter(node => !node.disabled && node.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    this.querySelector('[data-ep-copy]')?.addEventListener('click', async event => {
      try {
        await navigator.clipboard.writeText(event.currentTarget.dataset.code);
        this.querySelector('[data-ep-copy-hint]').textContent = this.dataset.copiedText;
      } catch {}
    });
    this.querySelector('form').addEventListener('submit', event => this.submit(event));
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    document.removeEventListener('scroll', this.scrollHandler, true);
    document.removeEventListener('mouseout', this.exitHandler);
  }
  close() {
    try { localStorage.setItem(this.snoozeKey, String(Date.now() + Number(this.dataset.snoozeDays) * 864e5)); } catch {}
    this.hidden = true;
    this.classList.remove('is-open');
    document.documentElement.style.overflow = this.previousOverflow || '';
    this.previousFocus?.focus();
  }
  async submit(event) {
    event.preventDefault();
    const input = this.querySelector('input');
    const error = this.querySelector('[data-ep-error]');
    if (!input.checkValidity()) { error.hidden = false; input.focus(); return; }
    const button = this.querySelector('[data-ep-submit]');
    button.disabled = true;
    error.hidden = true;
    const email = input.value.trim();
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    if (this.dataset.company && this.dataset.list) fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.company)}`, {
      method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: this.dataset.source,
        profile: { data: { type: 'profile', attributes: { email, properties: { signup_source: this.dataset.source } } } },
      }, relationships: { list: { data: { type: 'list', id: this.dataset.list } } } } }),
    }).catch(() => {});
    try {
      const response = await fetch(this.dataset.capture, {
        method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, keepalive: true, signal: controller.signal,
        body: JSON.stringify({ shop: this.dataset.shop, email, source: this.dataset.source, company: this.dataset.company, list: this.dataset.list }),
      });
      const result = await response.json();
      if (!response.ok || result.ok !== true) throw new Error('Capture failed');
      try { localStorage.setItem(this.doneKey, '1'); } catch {}
      this.classList.add('is-success');
      this.querySelector('[data-ep-state="form"]').hidden = true;
      this.querySelector('[data-ep-state="success"]').hidden = false;
      this.querySelector('[data-ep-copy]')?.focus();
    } catch {
      error.textContent = this.dataset.retryText;
      error.hidden = false;
    } finally { clearTimeout(timeout); button.disabled = false; }
  }
}
if (!customElements.get('elirena-email-popup')) customElements.define('elirena-email-popup', VinebiEmailPopup);
